import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05909062"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-claim__info-container" }
const _hoisted_2 = { class: "m-claim__info-section m-claim__header-information" }
const _hoisted_3 = { class: "m-claim__title" }
const _hoisted_4 = ["data-workspace", "data-subscribe-link"]
const _hoisted_5 = { class: "m-claim__info-section m-claim__information" }
const _hoisted_6 = { class: "m-claim__info-section m-claim__claim-details" }
const _hoisted_7 = {
  key: 3,
  class: "m-claim__partnership"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "In partnership with", -1))
const _hoisted_9 = { class: "m-claim__partner-logos" }
const _hoisted_10 = ["src", "alt", "id"]

import { computed } from 'vue';
import { VideoEmbed } from '@manifoldxyz/vue-component-library';
import ApproveSpendButton from '@/components/ApproveSpendButton.vue';
import BuyButton from '@/components/BuyButton.vue';
import ClaimDescription from '@/components/ClaimDescription.vue';
import ClaimSummary from '@/components/ClaimSummary.vue';
import Countdown from '@/components/Countdown.vue';
import Frame from '@/components/Frame.vue';
import SpecialNetworkBanner from '@/components/SpecialNetworkBanner.vue';
import { useClaimStore } from '@/store/claimStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClaimTileBody',
  setup(__props) {

_useCssVars(_ctx => ({
  "d1cf95da": (mediaContainerGrid.value.templateColumns.mobile),
  "a6c525d2": (mediaContainerGrid.value.templateRows.mobile),
  "fd69496c": (mediaContainerGrid.value.templateAreas.mobile),
  "5fb679cb": (mediaContainerGrid.value.templateColumns.desktop),
  "0a4f7b72": (mediaContainerGrid.value.templateRows.desktop),
  "882fcb18": (mediaContainerGrid.value.templateAreas.desktop)
}))

const store = useClaimStore();
const mainLogo = computed((): string => {
  return store.clientLogos?.main ?? '';
});
const partners = computed((): { id: string; url: string }[] => {
  return store.clientLogos?.partners ?? [];
});

/** styles for grid for media container */
const mediaContainerGrid = computed(() => {
  return {
    templateRows: {
      mobile: mainLogo.value ? '1fr 4fr' : '1fr',
      desktop: mainLogo.value ? '5fr 1fr' : '1fr',
    },
    templateColumns: {
      mobile: '1fr',
      desktop: mainLogo.value ? '2fr 3fr' : '1fr',
    },
    templateAreas: {
      mobile: mainLogo.value ? '"main-logo" "media"' : '"media"',
      desktop: mainLogo.value ? '"media media" "blank main-logo"' : '"media"',
    },
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Frame, {
    class: _normalizeClass(["m-project m-claim__frame", { portrait: true }]),
    "no-overflow": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(store).name), 1),
          _createElementVNode("div", {
            "data-widget": "m-wallet-identity",
            class: "manifold-scheme-dark m-claim__artist-info",
            "data-workspace": _unref(store).creator.id,
            "data-subscribe-link": `https://app.manifold.xyz/c/${_unref(store).slug}?utm_source=subscribed_artist`
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(ClaimDescription, {
            description: _unref(store).description
          }, null, 8, ["description"]),
          (_unref(store).clientVideoEmbed)
            ? (_openBlock(), _createBlock(_unref(VideoEmbed), {
                key: 0,
                poster: _unref(store).clientVideoEmbed.poster,
                src: _unref(store).clientVideoEmbed.src,
                title: _unref(store).clientVideoEmbed.title
              }, null, 8, ["poster", "src", "title"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(ClaimSummary, {
            total: _unref(store).total,
            "total-max": _unref(store).totalMax,
            "has-allowlist": _unref(store).hasAllowlist
          }, null, 8, ["total", "total-max", "has-allowlist"]),
          (_unref(store).status === 'active' && _unref(store).endDate && !_unref(store).isSoldOut)
            ? (_openBlock(), _createBlock(Countdown, {
                key: 0,
                class: "m-claim__countdown",
                "end-date": _unref(store).endDate
              }, null, 8, ["end-date"]))
            : _createCommentVNode("", true),
          _createVNode(SpecialNetworkBanner),
          (_unref(store).erc20Address && _unref(store).erc20ApprovedSpend.lt(_unref(store).cost))
            ? (_openBlock(), _createBlock(ApproveSpendButton, { key: 1 }))
            : (_openBlock(), _createBlock(BuyButton, {
                key: 2,
                class: "m-claim__action-button"
              })),
          (partners.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partners.value, (partner) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: partner.id,
                      src: partner.url,
                      alt: `${partner.id} logo`,
                      class: "m-claim__logo m-claim__logo--partner",
                      id: `partner-logo-${_unref(store).id}-${partner.id}`
                    }, null, 8, _hoisted_10))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})